import MaterialTable from 'material-table'
import { ThemeProvider } from '@mui/styles'
import { createTheme } from '@mui/material';

import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumnOutlined';

import AddBox from '@material-ui/icons/AddBox';
import Check from '@material-ui/icons/Check';
import Clear from '@material-ui/icons/Clear';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import * as XLSX from 'xlsx'
import React, { forwardRef, useEffect, useState } from 'react'
import './dataTableRewardLocation.scss'
import { contactColumns } from '../../data/dataSource';
import { Link } from 'react-router-dom';
import { collection,  deleteDoc, doc, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from '../../firebase'
import ConfirmBox from '../ConfirmBox';


const DataTable = () => {

  const [ data, setData ] = useState([])
  
  const [ isLoading, setIsLoading ] = useState(true)

  const [open, setOpen] = useState(false);

  const [deleteId, setDelete] = useState("");


  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }

 useEffect(() => {

// //LISTEN REAL TIME

    const collectionRef = collection(db, "contact")

    const queryRewards = query(collectionRef, orderBy("timeStamp", "desc"))

    const unsub = onSnapshot(queryRewards, (snapShot) => {

      let list = [];

      snapShot.docs.forEach((doc) => {

         list.push({id: doc.id, ...doc.data(),  date: doc.data().timeStamp.toDate().toLocaleDateString() });
       
      })
      setData(list)

      setIsLoading(false)
    }, 
      (error) => {
        console.log(error)
      }
    );

    return () => {
      unsub();
    }

//END LISTEN REAL TIME    

},[])


function openDelete(id) {

    setOpen(true);

    setDelete(id);
    
}


  
console.log(data)

const handleDelete = async() => {

    await deleteDoc(doc(db, "contact", deleteId));
    
    setData(data.filter((item) => item.id !== deleteId))

    setOpen(false)

}


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


    const theme = createTheme({
      status: {
        danger: 'red',
      },
    });

    const downloadExcel=()=>{
      const newData=data.map(row=>{
        delete row.tableData
        return row
      })
      const workSheet=XLSX.utils.json_to_sheet(newData)
      const workBook=XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workBook,workSheet,"contact")
      //Buffer
      let buf=XLSX.write(workBook,{bookType:"xlsx",type:"buffer"})
      //Binary string
      XLSX.write(workBook,{bookType:"xlsx",type:"binary"})
      //Download
      XLSX.writeFile(workBook,"contact.xlsx")


    }

    
  return (
    <>
    <div style={{}}>
      {/* <h1 align="center">React-App</h1>
      <h4 align='center'>Export Data to Excel in Material Table</h4> */}

      {
        isLoading
        ?
        <Spinner/>
        :

        <>

          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', margin:20, paddingTop:20, paddingBottom:20,}}>
              {/* <h1 style={{fontSize:20, color:'#666'}}>Contact List</h1>
               <Link to="/rewardlocation/new"  style={{textDecoration:"none", fontSize:22, flexDirection:'row', gap:10, display:'flex', alignItems:'center'}} >
                  <AddCircleOutlineIcon style={{ color:'#999', fontSize:28}}/>
                  <div className='link'>
                    Add New Location
                  </div>
                </Link> */}
            </div>

          <ThemeProvider theme={theme}>

            <MaterialTable
            icons={tableIcons}
            title="All Website Contacts"
            columns={contactColumns}
            data={data}


          actions={[
            // not working

            { 
              action: rowData => ({
                icon: tableIcons.ViewColumn,
                tooltip: "View Website Contact",
                onClick: (event, rowData) => window.location.href=`/contacts/${rowData.id}` 
              }),
              position: "row"
            },

            {
              action: rowData => ({
                icon: tableIcons.Delete,
                tooltip: "Delete Website Contact",
                onClick: (event, rowData) => openDelete(rowData.id)
              }),
              position: "row"
            },
              {icon:()=><button>Export</button>,// you can pass icon too
              tooltip:"Export to Excel",
              onClick:()=>downloadExcel(),
              isFreeAction:true
              },
          ]}


            options={{
              exportButton: true,
              sorting: true,
              selection: true,
              actionsColumnIndex: -1,
              exportCsv: (columns, data) => {
                downloadExcel()
              },

              headerStyle: {
                // backgroundColor: '#01579b',
                fontWeight: 'bold',
                fontSize: 16
              }
            }}

            />
          </ThemeProvider>
               
        </>
        

        

      }

    
    </div>

    <ConfirmBox
      open={open}
      closeDialog={() => setOpen(false)}
      deleteFunction={handleDelete}
    />
    </>
  );
}

export default DataTable;








